import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import { InformationService } from '@core/store/services/information.service';
import * as informationActions from '@core/store/actions/information.actions';
import { InformationActionTypes } from '@core/store/actions/information.actions';
import { of } from 'rxjs';

@Injectable()
export class InformationEffects {
  constructor(private informationService: InformationService, private actions$: Actions) {}

  loadData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InformationActionTypes.LoadData),
      exhaustMap(action => {
        return this.informationService.getInformation().pipe(
          map(information => new informationActions.LoadSuccess(information)),
          catchError(error => of(new informationActions.LoadFail(error)))
        );
      })
    );
  });

  loadBanners$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InformationActionTypes.LoadBanners),
      exhaustMap(action => {
        return this.informationService.getBanners().pipe(
          map(banners => new informationActions.LoadBannersSuccess(banners)),
          catchError(error => of(new informationActions.LoadBannersFail(error)))
        );
      })
    );
  });
}
